// EFFECT TILE FACE — the styled-`Aa` "icon" for a text effect on the Row-2
// EFFECTS section (owner, 2026-07-20: "we have enough space to add the other
// effects like shadows, echo, glow and outline as icons in the ribbon too").
//
// ONE SOURCE, matched to depthTileFaces exactly. The Bevel/3D faces
// (inspector/text/depthTileFaces) render a styled `Aa` span for two fx steps
// that live OUTSIDE effectDefs. These eight faces render the SAME idiom for the
// eight effects that DO live in effectDefs — so the LOOK comes straight from
// each def's `tilePreview()`, the very CSS the drawer's Style-tab tiles paint
// (EffectTiles.jsx). Row 2 and the drawer can never drift because both read one
// source: EFFECT_DEFS[id].tilePreview(). No fork, no second style table.
//
// The typographic BASE (family/weight/size/color) is the ribbon-owned
// `.cce-fx-face` rule in ribbon.css — the same split depthTileFaces uses
// (`.cce-depth-face` owns SIZE; the look rides inline). Keeping the base in
// ribbon.css (not an inline object, and not the drawer's `.cce-fx-tile-preview`
// which lives in StudioCoreEditor.css) means the face renders correctly in the
// ribbon lab too, which loads ribbon.css alone.
import React from 'react';
import { EFFECT_DEFS } from '../../inspector/text/effectDefs';

/**
 * A text effect's face — a styled `Aa` carrying the def's `tilePreview()` CSS.
 * @param {string} effectId  an EFFECT_DEFS key (shadow|lift|glow|echo|outline|
 *                           hollow|trace|sticker)
 * @param {string} [className]  variant hook (font-size lives on `.cce-fx-face`)
 */
export default function EffectTileFace({ effectId, className = '' }) {
  const def = EFFECT_DEFS[effectId];
  if (!def) return null;
  return (
    <span
      className={`cce-fx-face cce-fx-face-${effectId}${className ? ` ${className}` : ''}`}
      style={def.tilePreview()}
      aria-hidden="true"
    >
      Aa
    </span>
  );
}
